export const SUPPORTED_LOCALES = ["en-US", "pt-PT"] as const;

/** Convert app locale ("en-US" / "pt-PT") to the camelCase key used in Sanity localizedString fields ("enUS" / "ptPT"). */
export function toGroqLocale(locale: AppLocale): string {
  return locale === "pt-PT" ? "ptPT" : "enUS";
}

export type AppLocale = (typeof SUPPORTED_LOCALES)[number];

export function normalizeLocale(value?: string | null): AppLocale {
  return value === "pt-PT" ? "pt-PT" : "en-US";
}

export function withLang(href: string, locale: AppLocale): string {
  const [path, search = ""] = href.split("?");
  const params = new URLSearchParams(search);
  params.set("lang", locale);
  const query = params.toString();
  return query ? `${path}?${query}` : path;
}

export function localizeValue(
  value:
    | string
    | {
        enUS?: string;
        ptPT?: string;
      }
    | null
    | undefined,
  locale: AppLocale,
  fallback = ""
): string {
  if (typeof value === "string") {
    return value;
  }

  if (!value) {
    return fallback;
  }

  if (locale === "pt-PT") {
    return value.ptPT ?? value.enUS ?? fallback;
  }

  return value.enUS ?? value.ptPT ?? fallback;
}

export function formatCurrencyEUR(
  amount: number | null | undefined,
  locale: AppLocale = "en-US"
): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount ?? 0);
}
